var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7778 13H1.22222V5.05556H2.66667V11.5556H11.3333V5.05556H12.7778V13ZM0.5 0H13.5V4.33333H0.5V0ZM5.19444 5.77778H8.80556C9.00778 5.77778 9.16667 5.93667 9.16667 6.13889V7.22222H4.83333V6.13889C4.83333 5.93667 4.99222 5.77778 5.19444 5.77778ZM1.94444 1.44444V2.88889H12.0556V1.44444H1.94444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.fb70302e.svg";
export { ForwardRef as ReactComponent };